import { productsReferentialApiConnector } from 'apiConnector/products-referential';
import type { DynamicProduct, ProductsReferential, ProductVariation } from 'models/productsReferential';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import {
  dynamicProductsLoaded,
  productsReferentialLoaded,
  productsReferentialLoadingFailed,
} from 'state/productsReferential/productsReferential.action';
import type { EpicWithThunk } from 'state/state.common';

type RecentProductReferential = Omit<ProductsReferential, 'availableAssetTypes'>;
export type RecentProductWorkspaceType = keyof RecentProductReferential;

export interface FetchProductsReferentialApi {
  fetchProductsReferential(): Observable<ProductsReferential>;
  fetchDynamicProducts(): Observable<readonly DynamicProduct[]>;
  fetchRecentProducts(): Observable<RecentProductReferential>;
  addToRecentProduct(workspace: RecentProductWorkspaceType, variation: ProductVariation): Observable<unknown>;
}

export function fetchProductsReferentialOnUserInfoReceivedEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) =>
    actions$.pipe(
      ofType('PRODUCTS_REFERENTIAL_REQUESTED'),
      mergeMap(() =>
        productsReferentialApiConnector(httpClient)
          .fetchProductsReferential()
          .pipe(
            map(productsReferentialLoaded),
            catchError((err: Error) =>
              of(
                productsReferentialLoadingFailed(err.message),
                showNotificationThunk({ level: 'danger', title: 'productReferentialFailure.title' }),
              ),
            ),
          ),
      ),
    );
}

export function fetchDynamicProductsEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) =>
    actions$.pipe(
      ofType('DYNAMIC_PRODUCTS_REQUESTED'),
      mergeMap(() =>
        productsReferentialApiConnector(httpClient)
          .fetchDynamicProducts()
          .pipe(
            map(dynamicProductsLoaded),
            catchError((err: Error) =>
              of(
                productsReferentialLoadingFailed(err.message),
                showNotificationThunk({ level: 'danger', title: { id: 'productReferentialFailure.title' } }),
              ),
            ),
          ),
      ),
    );
}
